module.exports = __webpack_public_path__ + "static/media/operador-logo-porto-seguro.58a7f28f.svg";